import React from 'react';
import Typography from '@mui/material/Typography';

export default function ShowTypographyModule({data, style, extraProperties}) {
    return (
        <Typography variant={extraProperties.variant ? extraProperties.variant : 'body1'} sx={[style ? style : {}]}> 
            {data ? data : 'Text'}
        </Typography>
    )
}